<template>
  <section class="vacancies-template">
    <div v-if="content">
      <h1>{{ content.title }}</h1>
      <p v-html="content.intro"></p>
      <div
        v-for="(vacancy, index) in content.list"
        :key="index"
        class="vacancy"
        :class="{ 'vacancy--open': activeVacancy === index }"
      >
        <button @click="toggleVacancy(index)" class="vacancy__title">
          {{ vacancy.title }}
          <span
            :class="{
              'vacancy__arrow': true,
              'vacancy__arrow--up': activeVacancy === index
            }"
          >
            ▼
          </span>
        </button>
        <div
          class="vacancy__details"
          :class="{ 'vacancy__details--open': activeVacancy === index }"
        >
          <!-- Роль вакансии вместо описания -->
          <div v-if="vacancy.role" class="vacancy__item">
            <div class="vacancy__item-title">{{ vacancy.role.title }}</div>
            <div v-html="vacancy.role.description"></div>
            <ul class="vacancy__list">
              <li v-for="(item, i) in vacancy.role.details" :key="'r-' + i" v-html="processText(item)"></li>
            </ul>
          </div>

          <div
            v-if="vacancy.responsibilities"
            class="vacancy__item"
          >
            <div class="vacancy__item-title">{{ vacancy.responsibilities.title }}</div>
            <ul class="vacancy__list">
              <li v-for="(item, i) in vacancy.responsibilities.details" :key="'r-' + i" v-html="processText(item)"></li>
            </ul>
          </div>

          <div
            v-if="vacancy.experience"
            class="vacancy__item"
          >
            <div class="vacancy__item-title">{{ vacancy.experience.title }}</div>
            <ul class="vacancy__list">
              <li v-for="(item, i) in vacancy.experience.details" :key="'e-' + i" v-html="processText(item)"></li>
            </ul>
          </div>

          <div
            v-if="vacancy.preferred"
            class="vacancy__item"
          >
            <div class="vacancy__item-title">{{ vacancy.preferred.title }}</div>
            <ul class="vacancy__list">
              <li v-for="(item, i) in vacancy.preferred.details" :key="'p-' + i" v-html="processText(item)"></li>
            </ul>
          </div>

          <div
            v-if="vacancy.offer"
            class="vacancy__item"
          >
            <div class="vacancy__item-title">{{ vacancy.offer.title }}</div>
            <ul class="vacancy__list">
              <li v-for="(item, i) in vacancy.offer.details" :key="'o-' + i" v-html="processText(item)"></li>
            </ul>
          </div>

        </div>
      </div>
    </div>
    <div v-else>
      <p>Content is loading...</p>
    </div>
  </section>
</template>

<script>
import { useVacanciesStore } from '@/stores/vacanciesStore';
import { watch } from 'vue';

export default {
  name: 'VacanciesTemplate',
  data() {
    return {
      activeVacancy: null
    };
  },
  computed: {
    vacanciesStore() {
      return useVacanciesStore();
    },
    content() {
      return this.vacanciesStore.content;
    }
  },
  methods: {
    toggleVacancy(index) {
      this.activeVacancy = this.activeVacancy === index ? null : index;
    },
    processText(text) {
      const parts = text.split(':');
      if (parts.length > 1) {
        // Если есть двоеточие, выделяем первую часть
        return `<strong>${parts[0]}:</strong> ${parts.slice(1).join(':')}`;
      }
      // Если двоеточия нет, возвращаем текст без изменений
      return text;
    }
  },
  mounted() {
    this.vacanciesStore.loadContent(this.$i18n.locale);

    watch(
      () => this.$i18n.locale,
      (newLocale) => {
        this.vacanciesStore.loadContent(newLocale);
      },
      { immediate: true }
    );
  }
};
</script>
